import axiosInstance from "./axiosInstance";

const getUserNotifications = async () => {
  const response = await axiosInstance.get("notifications");
  return response.data;
};

const getAdminNotifications = async () => {
  const response = await axiosInstance.get("notifications/admin");
  return response.data;
};

const readNotification = async (id: string) => {
  const response = await axiosInstance.patch(`notifications/${id}/read`);
  return response.data;
};

const readMultipleNotifications = async (ids: string[]) => {
  const response = await axiosInstance.patch("notifications/bulk/read", { ids });
  return response.data;
};

const deleteNotification = async (id: string) => {
  const response = await axiosInstance.delete(`notifications/${id}`);
  return response.data;
};

const deleteMultipleNotifications = async (ids: string[]) => {
  const response = await axiosInstance.delete("notifications/bulk", { data: { ids } });
  return response.data;
};

export const notificationService = {
  getUserNotifications,
  getAdminNotifications,
  readNotification,
  readMultipleNotifications,
  deleteNotification,
  deleteMultipleNotifications,
};
